import * as S from './styles';
import { useCalcPrice } from '@/talons';
import { useCallback, useMemo, useState } from 'react';
import { CardMode, PackagesTypesProps, ProductProps } from '@/types';
import { ModalCustomAttributes, ModalFlexDiscount, Product, Slider } from '@/components';
import { copy } from '@/shared/commonFunctions';

interface Products {
  id: string;
  dots?: boolean;
  cardMode: CardMode;
  products: ProductProps[];
  slideToShow?: number | 'auto';
  onProductNavigate?: (productId: number) => void;
  addProductToCart: ({
    sku,
    uid,
    option_uid,
    quantity,
    category_id,
  }: {
    sku: number;
    uid: string;
    quantity: number;
    option_uid: string;
    category_id: number;
  }) => void;
  updateProductAmount: ({ sku, uid, quantity }: { sku: number; uid: string; quantity: number }) => void;
  removeProductFromCart: ({ uid }: { uid: string }) => void;
  setPageLastPurchase?: (page: number) => void;
}

const RenderSliderProducts = ({
  id,
  dots,
  cardMode,
  products,
  slideToShow,
  setPageLastPurchase,
  onProductNavigate,
}: Products) => {
  const { substTrib } = useCalcPrice();
  const [isOpenedModal, setOpenModal] = useState(false);
  const [openAttributesModal, setOpenAttributesModal] = useState(false);
  const [packQuantity, setPackQuantity] = useState(0);
  const [packaging, setPackage] = useState('' as PackagesTypesProps);
  const [product, setProduct] = useState(null as ProductProps | null);

  const handleModalInfos = useCallback(
    (product: ProductProps, pack: PackagesTypesProps, packQuantity: number) => {
      setProduct(product);
      setPackage(pack);
      setPackQuantity(packQuantity);
      setTimeout(() => setOpenAttributesModal(true), 300);
    },
    [setProduct, setOpenAttributesModal]
  );

  // MODIFICAÇÃO AQUI: handleModalFlex agora aceita pack e packQty
  const handleModalFlex = useCallback(
    (prod: ProductProps, selectedPack: PackagesTypesProps, selectedPackQty: number) => {
      const product = copy(prod);
      setProduct(product);
      setPackage(selectedPack);
      setPackQuantity(selectedPackQty);
      setTimeout(() => setOpenModal(true), 300);
    },
    [setProduct, setPackage, setPackQuantity]
  );

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    setProduct(null);
    setPackage('' as PackagesTypesProps);
    setPackQuantity(0);
  }, [setOpenModal, setProduct, setPackage, setPackQuantity]);

  // Adicionado handleModalFlex e handleModalInfos nas dependências do useMemo
  const promocoes = useMemo(
    () =>
      products?.map((item: ProductProps, ind: number) => (
        <S.ProductContainer key={`${id}-${ind}`}>
          <Product
            direction={cardMode}
            product={{ ...item }}
            handleModalFlex={handleModalFlex} // Passando a função handleModalFlex
            handleModalInfos={handleModalInfos} // Passando a função handleModalInfos
            onProductNavigate={onProductNavigate ? () => onProductNavigate(item.COD_PRODUTO) : undefined}
          />
        </S.ProductContainer>
      )) || [],
    [products, cardMode, id, handleModalFlex, handleModalInfos, onProductNavigate]
  ); // Adicionado handleModalFlex e handleModalInfos nas dependências

  return (
    <>
      <Slider
        id={id}
        canSwipe
        dots={dots}
        slides={promocoes}
        slidesToShow={slideToShow ?? 'auto'}
        className="promotional"
        setActiveIndex={setPageLastPurchase ? setPageLastPurchase : () => {}}
      />

      <ModalFlexDiscount
        pack={packaging}
        product={product as ProductProps}
        packQty={packQuantity}
        substTrib={substTrib}
        isOpenedModal={isOpenedModal}
        setPackage={setPackage}
        openModal={handleCloseModal}
        setPackQuantity={setPackQuantity}
      />

      {product && (
        <ModalCustomAttributes
          product={product}
          pack={packaging}
          packQuantity={packQuantity}
          isOpen={openAttributesModal}
          openModal={setOpenAttributesModal}
        />
      )}
    </>
  );
};

export default RenderSliderProducts;
